import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CountdownUnit = ({ value, label }) => (
    <div className="countdown-card">
        <span className="countdown-value">{value}</span>
        <span className="countdown-label">{label}</span>
    </div>
);

const ExamTimer = ({ title, date, colorClass }) => {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date().getTime();
            const difference = date - now;

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };
        const timer = setInterval(calculateTimeLeft, 1000);
        calculateTimeLeft();
        return () => clearInterval(timer);
    }, [date]);

    const timeUnits = [
        { label: 'GÜN', value: timeLeft.days },
        { label: 'SAAT', value: timeLeft.hours },
        { label: 'DK', value: timeLeft.minutes },
        { label: 'SN', value: timeLeft.seconds }
    ];

    return (
        <div className={`exam-timer-block ${colorClass}`}>
            <h3 className="exam-title">{title}</h3>
            <p className="exam-date">{new Date(date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
            <div className="countdown-grid-compact">
                {timeUnits.map((unit, index) => (
                    <CountdownUnit key={index} value={unit.value} label={unit.label} />
                ))}
            </div>
        </div>
    );
};

const ExamCountdown = () => {
    // Tentative Dates for 2026
    const tytDate = new Date('2026-06-20T10:15:00').getTime();
    const aytDate = new Date('2026-06-21T10:15:00').getTime();

    return (
        <section className="section countdown-section">
            <div className="container">
                <div className="countdown-header">
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="section-title text-center"
                    >
                        YKS 2026 Geri Sayım
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="section-subtitle text-center"
                    >
                        Hedefin için her saniye değerli.
                    </motion.p>
                </div>

                <div className="exams-container">
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="exam-wrapper"
                    >
                        <ExamTimer title="TYT (Temel Yeterlilik)" date={tytDate} colorClass="tyt-theme" />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 }}
                        className="exam-wrapper"
                    >
                        <ExamTimer title="AYT (Alan Yeterlilik)" date={aytDate} colorClass="ayt-theme" />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default ExamCountdown;
